export const Routes = {
  SERVICES_PAGE: '/services',
  SUBSCRIPTIONS_PAGE: '/services/subscriptions',
};
